import { loaderCreator } from '@/services/loaderPlugin/_base'
import { CONSENT_TYPES, addToConsentCallbackStore } from '@/utils/cookieConsent'
import { loadGA4 } from '@/utils/ga4'

export default loaderCreator(() => {
  addToConsentCallbackStore(CONSENT_TYPES.ANALYTICS, (hasConsent) => {
    if (!hasConsent) return
    loadGA4()
  })
})
